import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { eventListData, eventListType } from './betStopReason.model';
import { LocalizationService } from '@services/localization.service';

@Component({
  selector: 'betStopReason-component',
  templateUrl: './betStopReason.component.html',
  styleUrls: ['./betStopReason.sass'],
})
export class BetStopReasonComponent implements OnChanges {
  public eventType: number;
  public eventName: string;
  public teamName: string;
  public eventScore: string;
  public homeTeamScore: string;
  public awayTeamScore: string;
  public eventIcon: string;
  public isShowEvent = false;
  public isScore = false;
  public extraStyle = '';
  private _betStopReasonId: number;
  private eventList: eventListType = eventListData;
  @Input() homeTeamName: string;
  @Input() awayTeamName: string;
  @Input() teamScore: { homeTeamScore: string; awayTeamScore: string };
  @Input() isLive: boolean;
  @Input() page: 'header' | 'matchRow';
  @Input() get betStopReasonId() {
    return this._betStopReasonId;
  }
  set betStopReasonId(value) {
    const isShowEventList = Object.values(this.eventList)
      .filter(item => item.isShow && item.pageControl.includes(this.page))
      .map(item => item.key);
    if (value !== 0 && isShowEventList.includes(value)) {
      this.eventType = value;
      this.isShowEvent = true;
    } else {
      this.isShowEvent = false;
    }
  }

  constructor(private _LocalizationService: LocalizationService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.eventType) {
      if (changes.betStopReasonId) {
        this.eventNameChange(this.eventType);
        this.scoreStateChange(this.eventType);
        this.teamNameChange(this.eventType);
        this.styleChange(this.eventType);
        this.iconChange(this.eventType);
        this.teamScoreChange(this.teamScore);
      }
      if (changes.teamScore) {
        this.teamScoreChange(this.teamScore);
      }
    }
  }

  teamScoreChange(value: { homeTeamScore: string; awayTeamScore: string }) {
    if (value?.homeTeamScore && value?.awayTeamScore) {
      this.homeTeamScore = value.homeTeamScore;
      this.awayTeamScore = value.awayTeamScore;
      this.eventScore = `${value.homeTeamScore}-${value.awayTeamScore}`;
    }
  }

  iconChange(value: number) {
    this.eventIcon = this.eventList[value].icon;
  }

  eventNameChange(value: number) {
    this.eventName = this.eventList[value].eventName;
  }

  scoreStateChange(value: number) {
    this.isScore = this.eventList[value].isScore;
  }

  teamNameChange(value: number) {
    const item = this.eventList[value];
    if (item.eventTeamType === 'home') {
      this.teamName = this.homeTeamName;
    } else if (item.eventTeamType === 'away') {
      this.teamName = this.awayTeamName;
    } else {
      this.teamName = 'none';
    }
  }

  styleChange(value: number) {
    this.extraStyle = this.eventList[value].extraStyle;
  }
}
